import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useDkvCostImportsApi } from "../../http/dkvCostImports/api";
import { useDkvTollImportsApi } from "../../http/highwayTollCostImports/api";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import CostsImportForm, { CostsImportFormBody } from "./CostsImportForm";

const CostsImportButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dkvCostImportsApi = useDkvCostImportsApi();
  const highwayTollImportsApi = useDkvTollImportsApi();

  const onSubmit = async (formData: CostsImportFormBody) => {
    if (!formData.fileCsv) {
      return dispatch(showErrorNotification(i18n, null, i18n.t.common.noFileSelected));
    }

    const form = new FormData();
    form.append("file", formData.fileCsv); // input file
    form.append("subsidiaryId", formData.subsidiary.id);

    setIsSubmitting(true);
    try {
      if (formData.type.value == "dkv") {
        await dkvCostImportsApi.dkvUploadCsv(form);
      }
      if (formData.type.value == "tolls") {
        await highwayTollImportsApi.dkvTollsImportUploadCsv(form);
      }
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }}>{i18n.t.common.importCsv}</Button>
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.common.importCsv}>
          <CostsImportForm isDisabled={isSubmitting} onSubmit={onSubmit} isLoading={isSubmitting} />
        </ModalDialog>
      )}
    </>
  );
};

export default CostsImportButton;
